import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
} from '@ionic/react';

import { useLocation } from 'react-router-dom';
import './Menu.css';
import LanguageSwitcher from './LanguageSwitcher';
import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { menuTranslations } from '../translations/menu';
import { appPages } from './pagesData';

// const labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

const Menu: React.FC = () => {
  const location = useLocation();
  const { language } = useContext(LanguageContext);
  const t = menuTranslations[language];

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <IonList id="inbox-list">
          <IonListHeader>{t.header}</IonListHeader>
          <IonNote>{t.subheader}</IonNote>
          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                  <IonIcon slot="start" icon={appPage.icon} className="menuIcon" />
                  <IonLabel>{language === 'en' ? appPage.title_en : appPage.title}</IonLabel>
                </IonItem>
              </IonMenuToggle>
            );
          })}

          <LanguageSwitcher />
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
export {appPages};


// <IonList id="labels-list">
//   <IonListHeader>Labels</IonListHeader>
//   {labels.map((label, index) => (
//     <IonItem lines="none" key={index}>
//       <IonIcon slot="start" icon={bookmarkOutline} />
//       <IonLabel>{label}</IonLabel>
//     </IonItem>
//   ))}
// </IonList>
